import type { marked } from 'marked';

import type { RendererFn } from '../type';

export const hr: RendererFn<marked.Tokens.Hr> = (_, { key }) => {
  return <hr key={key} />;
};
